import { createSelector } from 'reselect';

export const selectRecap = (state: any) => state.get('recap');

const makeSelecClaimRecap = () =>
  createSelector(selectRecap, (recap: any) => {
    if (recap && recap.get('claimRecap')) {
      return recap.get('claimRecap').toJS();
    }
    return {};
  });

const makeSelectCorporealLawyers = () =>
  createSelector(selectRecap, recap => {
    if (recap && recap.get('corporealLawyers')) {
      return recap.get('corporealLawyers').toJS();
    }
    return [];
  });
const makeSelecOpenedClaim = () =>
  createSelector(selectRecap, (recap: any) => {
    if (recap && recap.get('openedClaim')) {
      return recap.get('openedClaim').toJS();
    }
    return {};
  });

const makeSelectCorporealExperts = () =>
  createSelector(selectRecap, recap => {
    if (recap && recap.get('corporealExperts')) {
      return recap.get('corporealExperts').toJS();
    }
    return [];
  });

const makeSelectSagisClaim = () =>
  createSelector(selectRecap, (recap: any) => {
    if (recap && recap.get('sagisClaim')) {
      return recap.get('sagisClaim').toJS();
    }
    return {};
  });
export {
  makeSelecClaimRecap,
  makeSelectCorporealLawyers,
  makeSelecOpenedClaim,
  makeSelectCorporealExperts,
  makeSelectSagisClaim,
};
